<template>
  <div class="bq-product-zhlc">
    <div class="bq-product-banner">
      <div
        class="bq-banner-cover"
        :style="{ backgroundImage: `url(${cover})` }"
      >
        <div class="bq-product-title-wrap" :class="animateTitle">
          <div
            class="bq-product-title"
            :style="{ backgroundImage: `url(${titlebg})` }"
          ></div>
          <div class="bq-product-line" v-show="false"></div>
          <div class="bq-product-subtitle">
            基于院内数据中心清洗、标化过的高质量数据，结合知识图谱、NLP技术和深度学习算法搭建临床所需的上层应用
          </div>
        </div>
      </div>
    </div>
    <BqTab :tabs="tabs" :activeIndex="activeIndex" @handleClick="handleClick">
      <div v-for="item in tabs" :key="item.slot" :slot="item.slot">
        <keep-alive>
          <component :is="item.slot"></component>
        </keep-alive>
      </div>
    </BqTab>
  </div>
</template>
<script>
import BqTab from '@/components/website_v3/Tab';
import qxst from './qxst';
import emar from './emar';
import bihuan from './bihuan';
export default {
  name: 'Zhlc',
  components: {
    BqTab,
    qxst,
    emar,
    bihuan,
  },
  data() {
    return {
      activeIndex: 0,
      animateTitle: [],
      titlebg:
        'https://img.alicdn.com/tfs/TB1CXEpFYj1gK0jSZFuXXcrHpXa-289-51.png',
      cover:
        'https://img.alicdn.com/tfs/TB17HKwE.T1gK0jSZFhXXaAtVXa-1920-380.png',
      tabs: [
        {
          title: '患者360全息视图',
          slot: 'qxst',
        },
        {
          title: 'eMAR（电子用药记录）',
          slot: 'emar',
        },
        {
          title: '闭环管理',
          slot: 'bihuan',
        },
      ],
    };
  },
  mounted() {
    setTimeout(() => {
      this.animateTitle = ['animate-title'];
    }, 10);
  },
  methods: {
    handleClick() {},
  },
};
</script>
<style lang="less" scoped>
@import '../../../../assets/styles/fn.less';

.bq-product-zhlc {
  .bq-product-banner {
    position: relative;
    width: 100%;
    height: 380px;
    overflow: hidden;
    color: #fff;

    .bq-banner-cover {
      width: 100%;
      height: 100%;
      .bgNoImg();
      position: relative;
      .bq-product-title-wrap {
        margin: 0 auto;
        position: absolute;
        top: 110px;
        // right: 360px;
        right: 50%;
        transform: translateX(50%);

        &.animate-title {
          .bq-product-title {
            animation: bounce 1s linear;

            @keyframes bounce {
              0% {
                opacity: 0;
                transform: translate3d(0, 500%, 0);
              }

              60% {
                transform: translate3d(0, -30px, 0);
              }

              80% {
                transform: translate3d(0, -10px, 0);
              }

              100% {
                opacity: 1;
                transform: translate3d(0, 0, 0);
              }
            }
          }

          .bq-product-subtitle {
            transform: translate3d(0, 0, 0);
            opacity: 1;

            animation: leftslide 1s ease;

            @keyframes leftslide {
              0% {
                opacity: 0;
                transform: translate3d(500%, 0, 0);
              }

              100% {
                opacity: 1;
                transform: translate3d(0, 0, 0);
              }
            }
          }
        }
      }

      .bq-product-title {
        // opacity: 0;
        margin-bottom: 50px;
        width: 313px;
        height: 51px;
        background-repeat: no-repeat;
        background-size: 100%;
      }

      .bq-product-line {
        width: 900px;
        height: 1px;
        background-color: #fff;
        box-shadow: 0 6px 2px 0 #00266f;
        margin-bottom: 20px;
      }
      .bq-product-subtitle {
        opacity: 0;
        width: 900px;
        text-align: left;
        font-size: 18px;
      }
    }
  }
}
</style>
